import React from 'react';
import '@cb/apricot/CBCard';
import '@cb/apricot/CBButton';
import '@cb/apricot/CBIcon';
import { Icon } from '@cb/apricot-react-icon';
import { useUIDSeed } from 'react-uid';
import cn from 'classnames';
export const ResourceCard = ({ titleId, descId, overlineId, title, titleHeadingLevel = 3, description, overline = 'DOCUMENT', resourceURL, resourceMetaInfo = [], icon = 'download', target, className, titleClassName, descriptionClassName, }) => {
    const seed = useUIDSeed();
    const titleIdCB = titleId || `apricot_${seed('title')}`;
    const descIdCB = description ? descId || `apricot_${seed('desc')}` : undefined;
    const overlineIdCB = overline ? overlineId || `apricot_${seed('overline')}` : undefined;
    const metaID = resourceMetaInfo.length > 0 ? `apricot_${seed('meta')}` : undefined;
    return (React.createElement("div", { className: cn('cb-card cb-card-title-link', className), "data-cbtrack-comp": "apricot-react:card" },
        React.createElement("div", { className: "cb-card-header" },
            React.createElement("p", { className: "cb-text-overline-small", id: overlineIdCB }, overline)),
        React.createElement("div", { className: "cb-card-content" },
            React.createElement("a", { href: resourceURL, "aria-describedby": `${overlineIdCB} ${descIdCB} ${metaID}`, target: target },
                React.createElement("p", { role: "heading", "aria-level": titleHeadingLevel, className: cn('cb-card-title', titleClassName), id: titleIdCB }, title)),
            React.createElement("p", { className: cn('cb-card-desc', descriptionClassName), id: descIdCB }, description),
            React.createElement("div", { className: "cb-card-action" },
                resourceMetaInfo && (React.createElement("ul", { className: "cb-meta-tags", id: metaID }, resourceMetaInfo.map((meta, index) => (React.createElement("li", { key: `resourceMeta_${index}` }, meta))))),
                React.createElement(Icon, { decorative: true, name: icon })))));
};
//# sourceMappingURL=ResourceCard.js.map